import * as React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { deleteHarvestScrap } from '../../../redux/slices/harvestScrapSlice';
import useLocales from '../../../hooks/useLocales';

HarvestScrapDeleteModal.propTypes = {
  passedData: PropTypes.any,
  open: PropTypes.bool,
  single: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default function HarvestScrapDeleteModal({ passedData, open, handleClose, single }) {
  const dispatch = useDispatch();
  const { translate } = useLocales();

  const handleDelete = () => {
    dispatch(deleteHarvestScrap({ device: window.navigator.userAgent, data: passedData }));
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="remove-harvest-scrap-dialog">
      <DialogTitle id="remove-harvest-scrap-dialog">{translate('deletePopupTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {single ? translate('deletePopupMessageOneItem') : translate('deletePopupMessageMultipleItems')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" autoFocus onClick={handleClose}>
          {translate('cancel')}
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete} autoFocus>
          {translate('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
